import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {Observable,throwError,TimeoutError,Subject,of,BehaviorSubject} from "rxjs";
import { map, catchError, timeout, filter } from "rxjs/operators";
import { Location } from "@angular/common";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { ProposalService } from "./proposal/proposal.service";
import * as moment from "moment";
import { io, Socket } from 'socket.io-client';
import { ToasterService } from "./toaster.service";

declare var Stripe: any;
@Directive()
@Injectable({
  providedIn: "root",
})
export class MainService {
  @Output() cardResponse = new EventEmitter<{
    token: object;
    save_card: number;
  }>();
  env: any = environment;
  data: any;
  reasons: any;
  LABEL: any;
  patient_id: number;
  public fixed_flat_fee: any;
  public recurring_extra_amount: any;
  public messageList: string | any[];
  public loader: boolean;
  public showLanguage: boolean = true;
  public toaster: any = this.toasterService;
  paymentData: any;
  currency_data = {
    display_logo: "",
    default_mobile_code: "",
    country_code: "",
    currency_code: "",
  };
  style = {
    base: {
      iconColor: "#F99A52",
      color: "#32315E",
      lineHeight: "40px",
      fontWeight: 400,
      fontSize: "14px",
      "::placeholder": {
        color: "#909090",
      },
    },
  };
  // tslint:disable-next-line:max-line-length
  public stripe_element: {
    unmount: (arg0: string) => void;
    mount: (arg0: string) => void;
    clear: () => void;
    update: (arg0: {
      style?: {
        base: {
          color: string;
          fontSize: string;
          fontWeight: string;
          fontFamily: string;
          "::placeholder": {
            fontWeight: number;
            fontFamily: string;
            color: string;
            fontSize: string;
          };
        };
      };
      hidePostalCode: boolean;
    }) => void;
    on: (
      arg0: string,
      arg1: { (event: any): void; (event: any): void }
    ) => void;
    addEventListener: (
      arg0: string,
      arg1: {
        ({ data, error }: { data: any; error: any }): void;
        ({ data, error }: { data: any; error: any }): void;
        ({ data, error }: { data: any; error: any }): void;
        ({ data, error }: { data: any; error: any }): void;
        ({ data, error }: { data: any; error: any }): void;
        ({ data, error }: { data: any; error: any }): void;
      }
    ) => void;
    _parent: { id: any };
  };
  // tslint:disable-next-line:max-line-length
  // public stripe: { elements: () => { (): any; new(): any; create: { (arg0: string, arg1: { hidePostalCode: boolean; style: { base: { iconColor: string; color: string; lineHeight: string; fontWeight: number; fontSize: string; '::placeholder': { color: string; }; }; }; }): any; new(): any; }; }; createToken: (arg0: any, arg1: { address_country?: any, name?: any; pay_recurring_token?: any; pf_id?: any; payment_source_type?: number; stripe_token?: string; card_token?: string; contract_id?: any; next_payment_date?: string; amount?: string | number; late_fee?: number; payment_mode?: number; transaction_fee?: number; pay_by_default?: string; upi_type?: number; }) => Promise<any>; confirmCardPayment: (arg0, arg1, arg2) => Promise<any>; confirmCardSetup: (arg0, arg1: Object) => Promise<any> ; retrieve, retrievePaymentIntent: (arg0) => Promise<any>, _apiKey};
  public cardCvcElement: {
    unmount: (arg0: string) => void;
    mount: (arg0: string) => void;
    clear: () => void;
    update: (arg0: {
      style?: {
        base: {
          color: string;
          fontSize: string;
          fontWeight: string;
          fontFamily: string;
          "::placeholder": {
            fontWeight: number;
            fontFamily: string;
            color: string;
            fontSize: string;
          };
        };
      };
      hidePostalCode: boolean;
    }) => void;
    on: (
      arg0: string,
      arg1: { (event: any): void; (event: any): void }
    ) => void;
    addEventListener: (
      arg0: string,
      arg1: {
        ({ data, error }: { data: any; error: any }): void;
        ({ data, error }: { data: any; error: any }): void;
        ({ data, error }: { data: any; error: any }): void;
        ({ data, error }: { data: any; error: any }): void;
        ({ data, error }: { data: any; error: any }): void;
        ({ data, error }: { data: any; error: any }): void;
      }
    ) => void;
    _parent: { id: any };
  };
  public stripe_pk: string;
  public stripe: any;
  stripeKeySubject = new Subject<any>();
  stripeKeyBehaviourSubject = new BehaviorSubject<string>('');
  constants = {
    SUBSCRIPTION_EXPIRED_FLAG: 403,
    expire_type: {
      INVALID: "INVALID",
      SUBSCRIPTION_EXPIRE: "SUBSCRIPTION_EXPIRE",
    },
  };
  // public config: ToasterConfig = new ToasterConfig({
  //   positionClass: "toast-bottom-center",
  //   animation: "fade",
  //   limit: 1,
  // });
  public subject = new Subject<any>();
  private loaderSubject = new Subject<any>();
  public headers: any = new HttpHeaders({
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  });
  public newHeaders: any = new HttpHeaders({
    "Content-Type": "application/json",
    Accept: "*/*",
  });
  public history = [];
  private zipRequestCache: { [key: number]: Observable<any> } = {};
  private zipCache: { [key: number]: any } = {};
  public patientBasicData = new Subject<any>();
  urlArray = ["payment-completed", "thanks", "personal-details"];
  public contractSupport = false;
  walletActionSubject: Subject<any> = new Subject();
  featureList = [];
  strike_enrollment_fee = "99.00";
  strike_transaction_fee = 3.0;
  strike_transaction__below_fee = 3.0;
  public promotionalEnrollmentOffer = true;
  public promotionalTransactionOffer = true;
  promotionalofferValue = 0;
  public current_step = 2;
  public new_current_step = 3;
  public new_paymentFlow_step = 1;
  public country_data$: BehaviorSubject<any> = new BehaviorSubject([]);
  public createContractData: BehaviorSubject<any> = new BehaviorSubject([]);
  public stripeTokenData: BehaviorSubject<any> = new BehaviorSubject([]);
  public cardSelectedData: BehaviorSubject<any> = new BehaviorSubject([]);
  public topHeader: BehaviorSubject<any> = new BehaviorSubject(false);
  public country_data = [];
  public verified = 0;
  public paymentSuccessful = false;
  public dynamicWidth = '0%';
  public signature;
  public is_generate_signature = 1;
  public is_reload = false;
  public paymentFail = false;
  public ofczip;
  public zipCode;
  public empzip;
  public unlockBenefits = false;
  successMessage = `Your file has been successfully saved`;
  socketIDS = {
    START_LOADING: "START_LOADING",
    STOP_LOADING: "STOP_LOADING",
  };

  payment_method_type_selected = {
    RECURRING: "recurring_type",
    BACKUP: "backup_type",
    PRIMARY: "primary_type",
  };

  // for new stripe payment intents elements

  public stripePaymentIntent;
  public linkAuthenticationElement;
  public stripeElementPaymentIntent;
  public stripeElement2PaymentIntent;

  // this is for gpay, applepay, links
  public paymentRequestLinkMethods;
  public paymentRequestPaymentIntent;

  // address element
  public stripeAddressElement;
  public mobile_code_arr = [];
  showSSNFields = true;
  document_label = "Document ID";
  document_ids_list = "";
  minDocumentIdLength = 5;
  maxDocumentIdLength = 15;
  public closeBtnHanling = false;
  public closePayBtn = false;
  language_data$: BehaviorSubject<any> = new BehaviorSubject([]);
  // pageReloadForCanadaBank: any = new BehaviorSubject<any>(false);
  showAddBankButton = false;
  noDecimalCurrencies: string[] = ['jpy', 'krw'];
  bankAdded$: BehaviorSubject<any> = new BehaviorSubject(false);
  mobile$: BehaviorSubject<any> = new BehaviorSubject([]);
  closeModalSteps: BehaviorSubject<any> = new BehaviorSubject(false);
  public regex$: BehaviorSubject<any> = new BehaviorSubject([]);
  showSuccess:boolean = false;
  countryWiseRegex = {
    US: {
      regex: /(\d{3})(\d{3})(\d{4})/g,
      group: "$1-$2-$3",
    },
    CA: {
      regex: /(\d{3})(\d{3})(\d{4})/g,
      group: "$1-$2-$3",
    },
    GB: {
      regex: /(\d{4})(\d{5})/g,
      group: "$1 $2",
    },
    AU: {
      regex: /(\d{1})(\d{4})(\d{4})/g,
      group: "$1 $2 $3",
    },
    NZ: {
      regex: /(\d{1})(\d{4})(\d{4})/g,
      group: "$1 $2 $3",
    },
    DE: {
      regex: /(\d{4})(\d{7})/g,
      group: "$1 $2",
    },
    IT: {
      regex: /(\d{3})(\d{7})/g,
      group: "$1 $2",
    },
    FR: {
      regex: /(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})/g,
      group: "$1 $2 $3 $4 $5",
    },
    ES: {
      regex: /(\d{3})(\d{6})/g,
      group: "$1 $2",
    },
    PL: {
      regex: /(\d{3})(\d{3})(\d{3})/g,
      group: "$1 $2 $3",
    },
    JP: {
      regex: /(\d{2})(\d{4})(\d{4})/g,
      group: "$1 $2 $3",
    },
  };
  DateFormating = {
    US: {
      formating: "M0/d0/0000",
      PlaceHolder: "MM/DD/YYYY",
      specialCharacters: ["/"],
    },
    CA: {
      formating: "0000-M0-d0",
      PlaceHolder: "YYYY-MM-DD",
      specialCharacters: ["-"],
    },
    GB: {
      formating: "d0/M0/0000",
      PlaceHolder: "DD/MM/YYYY",
      specialCharacters: ["/"],
    },
    AU: {
      formating: "d0-M0-0000",
      PlaceHolder: "DD-MM-YYYY",
      specialCharacters: ["-"],
    },
    NZ: {
      formating: "d0/M0/0000",
      PlaceHolder: "DD/MM/YYYY",
      specialCharacters: ["/"],
    },
    FR: {
      formating: "d0/M0/0000",
      PlaceHolder: "DD/MM/YYYY",
      specialCharacters: ["/"],
    },
    DE: {
      formating: "d0.M0.0000",
      PlaceHolder: "DD.MM.YYYY",
      specialCharacters: ["."],
    },
    IT: {
      formating: "d0/M0/0000",
      PlaceHolder: "DD/MM/YYYY",
      specialCharacters: ["/"],
    },
    JP: {
      formating: "0000/M0/d0",
      PlaceHolder: "YYYY/MM/DD",
      specialCharacters: ["/"],
    },
    PL: {
      formating: "d0.M0.0000",
      PlaceHolder: "DD.MM.YYYY",
      specialCharacters: ["."],
    },
    ES: {
      formating: "d0-M0-0000",
      PlaceHolder: "DD-MM-YYYY",
      specialCharacters: ["-"],
    },
  };
  defaultCountry = {
    country_code: "",
    country_id: "",
    country_name: "",
    mobile_code: "",
  };
  public dollarSign$: BehaviorSubject<any> = new BehaviorSubject("");
  public dateOfBirthMask;
  public placeFormat;
  public specialCharacter;
  finance_error_from = '';
  getDefaultCountry: any;
  support_data: any;

  constructor(
    public http: HttpClient,
    public toasterService: ToasterService,
    public router: Router,
    public location: Location,
    public _routes: ActivatedRoute,
    public socket: Socket
  ) // public proposal: ProposalService
  {
    this.socket = io(this.env.socketBaseUrl, { path: '/customer/socket.io' });

    this.loader = false;
    this.setLoader(false);
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
        // console.log('prev:', e.url);
        // console.log('urlAfterRedirects--',urlAfterRedirects);
        const current_path = window.location.pathname.split("/")[1];
        if (current_path && current_path != "") {
          if (this.urlArray.includes(current_path)) {
            this.contractSupport = true;
          } else {
            this.contractSupport = false;
          }
        }
        this.history = [...this.history, urlAfterRedirects];
      });

    this.dollarSign$.subscribe((data) => {
      if (data) {
        this.defaultCountry = data.country;
        this.dateOfBirthMask =
          this.DateFormating[this.defaultCountry["country_code"]]["formating"];
        this.placeFormat =
          this.DateFormating[this.defaultCountry["country_code"]][
          "PlaceHolder"
          ];
        this.specialCharacter =
          this.DateFormating[this.defaultCountry["country_code"]][
          "specialCharacters"
          ];
      }
      console.log(
        this.dateOfBirthMask,
        this.placeFormat,
        this.specialCharacter
      );
    });
  }
  getDatePlan(data: any) {
    if (data) {
      const dates = new Date(data); // Parse the date string
      const year = dates.getFullYear(); // Get the year (YYYY)
      const month = (dates.getMonth() + 1).toString().padStart(2, "0"); // Get the month (MM)
      const day = dates.getDate().toString().padStart(2, "0"); // Get the day (DD)
      const formating = this.dateOfBirthMask;

      // Replace placeholders with actual date values
      const formattedDate = formating && formating
        .replace("0000", year.toString())
        .replace("M0", month)
        .replace("d0", day);
      return formattedDate;
    }
  }
  getDatePlanUtc(data: any) {
    if (data) {
      const dates = new Date(data);
      const year = dates.getUTCFullYear();
      const month = (dates.getUTCMonth() + 1).toString().padStart(2, "0");
      const day = dates.getUTCDate().toString().padStart(2, "0");
      const formating = this.dateOfBirthMask;
      const formattedDate = formating && formating
        .replace("0000", year.toString())
        .replace("M0", month)
        .replace("d0", day);
      return formattedDate;
    }
  }

generateEmailToken(email:string){
  // const fixedIV = CryptoJS.enc.Utf8.parse('0000000000000000'); // used for get same token for same email if not used it give random token
  //  commented for  was just for testing 
  // let data =  CryptoJS.AES.encrypt(email, environment.emailTokenSalt,{ iv: fixedIV }).toString();
  // const decryptedEmail = CryptoJS.AES.decrypt(data, environment.emailTokenSalt).toString(CryptoJS.enc.Utf8);
  // console.log('dEmail', decryptedEmail)
  // return CryptoJS.AES.encrypt(email, environment.emailTokenSalt, { iv: fixedIV }).toString();
  // return data
  return btoa(email)
}




  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] || "";
  }

  public back() {
    this.location.back();
  }

  // urlParams(data: any) {
  //   const body = new URLSearchParams("", new customQueryEncoder());
  //   Object.keys(data).forEach((key) => {
  //     body.set(key, data[key]);
  //   });
  //   return body.toString();
  // }

  urlParams(data: any): string {
    const encoder = new customQueryEncoder();
    let params = new HttpParams();

    Object.keys(data).forEach((key) => {
      const encodedKey = encoder.encodeKey(key);
      const encodedValue = encoder.encodeValue(data[key]);
      params = params.set(encodedKey, encodedValue); // Reassign params (HttpParams is immutable)
    });

    return params.toString(); // Converts to the URL-encoded string
  }

  init() {
    this.LABEL = {
      doctor: "business owner",
      DOCTOR: "BUSINESS OWNER",
      Doctor: "Business Owner",
      patient: "customer",
      PATIENT: "CUSTOMER",
      Patient: "Customer",
      treatment: "service",
      TREATMENT: "SERVICE",
      Treatment: "Service",
      practice: "business",
      PRACTICE: "BUSINESS",
      Practice: "Business",
    };
    const params = {
      device_type: this.env.device_type,
      device_token: this.env.device_token,
      app_type: this.env.app_type,
      app_version: this.env.app_version,
      device_id: localStorage.getItem("user")
        ? localStorage.getItem("user")
        : this.guid(),
      environment: this.env.env,
    };
    this.loader = true;
    if (this.env.production) {
      delete params.environment;
    }
    if (!this.env.production) {
      params["environment"] =
        localStorage.getItem("environment") || environment.env;
    }
    const api_url = environment.request_url;
    // let api_url = localStorage.getItem('request_url');
    // if (!api_url) {
    //   api_url = environment.request_url;
    // }
    return this.http
      .post<any>(api_url + "get_settings", this.urlParams(params), {
        headers: this.headers,
      })
      .pipe(
        map((data: any) => {
          this.data = data;
          //           const hh =  this.generateString(5)
          // console.log(hh);

          // Stripe.setPublishableKey(this.data.stripe_pk);
          this.stripe = Stripe(this.data.stripe_pk);
          this.stripe_pk = this.data.stripe_pk;
          this.stripeKeySubject.next(this.data.stripe_pk);
          this.stripeKeyBehaviourSubject.next(this.data.stripe_pk);
          this.stripe_element = this.stripe
            .elements()
            .create("card", { hidePostalCode: false, style: this.style });
          this.cardCvcElement = this.stripe.elements().create("cardCvc");
          this.messageList = this.data.popups;
          this.sendMsg(this.data);
          // environment.request_url = data.server_url;
          // localStorage.setItem('baseUrl', environment.request_url)
          // localStorage.setItem('request_url', 'https://devapi.credee.com/customer/');
          this.loader = false;
          // this.strike_transaction_fee = data.PROMOTIONAL_TRANSACTION_FEE;
          // this.strike_enrollment_fee = '$' + data.PROMOTIONAL_ENROLLMENT_FEE;
          if (data.promotional_data && data.promotional_data.length) {
            data.promotional_data.forEach((item) => {
              if (item.enum === "TRANSACTION_ABOVE_THRESHOLD") {
                this.strike_transaction_fee = item.strike_value;
              }
              if (item.enum === "TRANSACTION_BELOW_THRESHOLD") {
                this.strike_transaction__below_fee = item.strike_value;
                if (item.isActive === "1") {
                  this.promotionalTransactionOffer = true;
                } else {
                  this.promotionalTransactionOffer = false;
                }
              }
              if (item.enum === "ENROLLMENT") {
                this.strike_enrollment_fee = item.strike_value;
                if (item.isActive === "1") {
                  this.promotionalEnrollmentOffer = true;
                } else {
                  this.promotionalEnrollmentOffer = false;
                }
              }
            });
          }
          if (data.mobile_code_arr && data.mobile_code_arr.length) {
            this.mobile_code_arr = data.mobile_code_arr;
            this.mobile$.next(data.mobile_code_arr);
          }
          if (data.country_data && data.country_data.length) {
            this.country_data$.next(data.country_data);
            this.country_data = data.country_data;
          }
          if (data.language_data && data.language_data.length) {
            this.language_data$.next(data.language_data);
          }
          return data;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  sendMsg(data) {
    this.reasons = data;
    this.subject.next(this.reasons);
  }

  getMsg() {
    return this.subject.asObservable();
  }

  guid() {
    const a = new Date();
    const nav = window.navigator;
    const screen = window.screen;
    let guid = nav.mimeTypes.length.toString();
    guid += nav.userAgent.replace(/\D+/g, "");
    guid += nav.plugins.length;
    guid += screen.height || "";
    guid += screen.width || "";
    guid += screen.pixelDepth || "";
    guid += a.getTime();
    return guid;
  }

  setLoader(data) {
    this.loader = data;
    this.loaderSubject.next(this.loader);
  }

  getLoader() {
    return this.loaderSubject.asObservable();
  }

  device_id(val: any) {
    const guidLog = this.guid();
    localStorage.setItem("user", guidLog);
  }
  getZipcode(val: any) {
    if (this.zipCache[val.zipcode]) {
      return of(this.zipCache[val.zipcode]);
    } else if (this.zipRequestCache[val.zipcode]) {
      return this.zipRequestCache[val.zipcode];
    } else {
      const params = {
        zipcode: val.zipcode,
      };
      if (val.search_canada) {
        params["search_canada"] = 1;
      }
      return this.http
        .post<any>(
          this.env.request_url + "get_zipcode",
          this.urlParams(params),
          { headers: this.headers }
        )
        .pipe(
          map((data: any) => {
            this.data = data;
            this.zipCache[params.zipcode] = data;
            return data;
          }),
          catchError((error: any) => {
            return throwError(error);
          })
        );
    }
  }

  flagPopUps(flag: any, error: any) {
    if (flag === 4) {
      return false;
    }

    if (!this.messageList || this.messageList.length === 0) {
      this.init();
    } else {
      for (let i = 0; i < this.messageList.length; i++) {
        if (
          flag === this.messageList[i].flag &&
          this.messageList[i].show_popup === 1
        ) {
          if (error === 1) {
            this.toasterService.message(this.messageList[i].text, 3);
          } else {
            this.toasterService.message(this.messageList[i].text, 1);
          }
        }
      }
    }
  }

  api(method: any, url: any, params: any) {
    if (method === 'post') {
      let headers = url.includes('store_financing_errors') ? new HttpHeaders({
        'Content-Type': 'application/json',
      }) : this.headers;
      return this.http
        .post<any>(url, params, {
          headers
        })
        .pipe(
          timeout(300000),
          map((data: any) => {
            return data;
          }),
          catchError((error: any) => {
            if (error instanceof TimeoutError) {
              this.toasterService.message(
                "Server Timeout, Try after sometime.",
                3
              );
              return throwError({ error: "Timeout Exception" });
            }
            return throwError(error);
          })
        );
    }
  }

  newApi(method: any, url: any, params: any) {
    if (method === "post") {
      return this.http
        .post<any>(url, params, {
          headers: this.newHeaders,
        })
        .pipe(
          timeout(300000),
          map((data: any) => {
            return data;
          }),
          catchError((error: any) => {
            if (error instanceof TimeoutError) {
              this.toasterService.message(
                "Server Timeout, Try after sometime.",
                3
              );
              return throwError({ error: "Timeout Exception" });
            }
            return throwError(error);
          })
        );
    }
  }
  getTransactionFee(contract, comparable_value, flag = 0, businessInfo = {}) {
    let isJPY = this.noDecimalCurrencies.includes(this.currency_data.currency_code.toLowerCase());

    // if(!contract){
    //   return '';
    // }
    comparable_value = parseFloat(comparable_value);
    comparable_value = Math.max(comparable_value, contract.downpayment_amount);
    contract.recurring_extra_amount = parseFloat(contract?.recurring_extra_amount);
    contract.recurring_extra_percent = parseFloat(contract.recurring_extra_percent);
    contract.threshold_amount = parseFloat(contract.threshold_amount);
    // tslint:disable-next-line:max-line-length
    contract.threshold_recurring_extra_amount = parseFloat(contract.threshold_recurring_extra_amount) || (businessInfo && businessInfo["threshold_recurring_extra_amount"] ? businessInfo["threshold_recurring_extra_amount"] : 0);
    // tslint:disable-next-line:max-line-length
    contract.threshold_recurring_extra_percent = parseFloat(contract.threshold_recurring_extra_percent) || (businessInfo && businessInfo["threshold_recurring_extra_percent"] ? businessInfo["threshold_recurring_extra_percent"] : 0);
    let text = "";
    if (comparable_value === 0) {
      return text;
    }
    if (comparable_value < contract.threshold_amount) {
      if (contract.recurring_extra_amount == 0 && contract.recurring_extra_percent == 0) {
        // transaction fee promotional check
        text += this.currency_data.display_logo + "0";
      }
      else {
        if (contract.recurring_extra_percent) {
          if (flag == 1) {
            text += `${contract.recurring_extra_percent.toFixed(2)}%`;
          }
          else {
            text += `${contract.recurring_extra_percent.toFixed(2)}%`;
          }
        }
        if (contract.recurring_extra_amount && contract.recurring_extra_percent) {
          text += " + ";
        }
        if (contract.recurring_extra_amount) {
          if (flag == 1) {
            text += this.currency_data.display_logo + `${contract.recurring_extra_amount.toFixed(isJPY ? 0 : 2)}`;
          }
          else {
            text += this.currency_data.display_logo + `${contract.recurring_extra_amount.toFixed(isJPY ? 0 : 2)}`;
          }
        }
      }
    } else {
      if (contract.threshold_recurring_extra_amount == 0 && contract.threshold_recurring_extra_percent == 0) {
        // transaction fee promotional check
        text += "0%";
      } else {
        if (contract.threshold_recurring_extra_percent) {
          if (flag == 1) {
            text += `${contract.threshold_recurring_extra_percent.toFixed(2)}%`;
          }
          else {
            text += `${contract.threshold_recurring_extra_percent.toFixed(2)}%`;
          }
        }
        if (contract.threshold_recurring_extra_amount && contract.threshold_recurring_extra_percent) {
          text += " + ";
        }
        if (contract.threshold_recurring_extra_amount) {
          if (flag == 1) {
            text += this.currency_data.display_logo + `${contract.threshold_recurring_extra_amount.toFixed(isJPY ? 0 : 2)}`;
          } else {
            text += this.currency_data.display_logo + `${contract.threshold_recurring_extra_amount.toFixed(isJPY ? 0 : 2)}`;
          }
        }
      }
    }
    return text;
  }

  getTransactionFeeStrike(contract, comparable_value, flag = 0) {
    console.log('contract', contract);
    let isJPY = this.noDecimalCurrencies.includes(this.currency_data.currency_code.toLowerCase());
    comparable_value = parseFloat(comparable_value);
    contract.recurring_extra_amount = parseFloat(contract.recurring_extra_amount);
    contract.recurring_extra_percent = parseFloat(contract.recurring_extra_percent);
    contract.threshold_amount = parseFloat(contract.threshold_amount);
    contract.threshold_recurring_extra_amount = parseFloat(contract.threshold_recurring_extra_amount) || 0;
    contract.threshold_recurring_extra_percent = parseFloat(contract.threshold_recurring_extra_percent) || 0;
    let text = "";
    if (comparable_value === 0) {
      return text;
    }
    if (comparable_value < contract.threshold_amount) {
      if (contract.recurring_extra_amount == 0 && contract.recurring_extra_percent == 0) {
        // transaction fee promotional check
        text += this.currency_data.display_logo + `${this.strike_transaction__below_fee.toFixed(2)}`;
      }
      else {
        if (contract.recurring_extra_percent) {
          if (flag == 1) {
            text += `${this.strike_transaction__below_fee.toFixed(2)}%`;
          }
          else {
            text += `${this.strike_transaction__below_fee.toFixed(2)}%`;
          }
        }
        if (contract.recurring_extra_amount && contract.recurring_extra_percent) {
          text += " + ";
        }
        if (contract.recurring_extra_amount) {
          if (flag == 1) {
            text += this.currency_data.display_logo + `${this.strike_transaction__below_fee.toFixed(isJPY ? 0 : 2)}`;
          } else {
            text += this.currency_data.display_logo + `${this.strike_transaction__below_fee.toFixed(isJPY ? 0 : 2)}`;
          }
        }
      }
    } else {
      if (contract.threshold_recurring_extra_amount == 0 && contract.threshold_recurring_extra_percent == 0) {
        // transaction fee promotional check
        text += `${this.strike_transaction_fee}%`;
      }
      else {
        if (contract.threshold_recurring_extra_percent) {
          if (flag == 1) {
            text += `${this.strike_transaction_fee.toFixed(2)}%`;
          }
          else {
            text += `${this.strike_transaction_fee.toFixed(2)}%`;
          }
        }
        if (contract.threshold_recurring_extra_amount && contract.threshold_recurring_extra_percent) {
          text += " + ";
        }
        if (contract.threshold_recurring_extra_amount) {
          if (flag == 1) {
            text += this.currency_data.display_logo + `${this.strike_transaction_fee.toFixed(isJPY ? 0 : 2)}`;
          } else {
            text += this.currency_data.display_logo + `${this.strike_transaction_fee.toFixed(isJPY ? 0 : 2)}`;
          }
        }
      }
    }
    return text;
  }

  calculateTransactionFeeStrike(recurring_amount, threshold_amount = 100) {
    if (recurring_amount < threshold_amount) {
      return (
        this.currency_data.display_logo + this.strike_transaction__below_fee
      );
    } else {
      return (
        this.currency_data.display_logo +
        ((recurring_amount / 100) * this.strike_transaction_fee).toFixed(2)
      );
    }
  }

  calculateTransactionFeeStrike2(recurring_amount, threshold_amount = 100, value) {
    if (recurring_amount < threshold_amount) {
      return (
        this.strike_transaction__below_fee + Number(value)
      );
    } else {
      return (
        
        (((recurring_amount / 100) * this.strike_transaction_fee) + Number(value)).toFixed(2)
      );
    }
  }

  getCalculatedTransactionFee(contract, comparable_value) {
    comparable_value = parseFloat(comparable_value);
    contract.recurring_extra_amount = parseFloat(
      contract.recurring_extra_amount
    );
    contract.recurring_extra_percent = parseFloat(
      contract.recurring_extra_percent
    );
    contract.threshold_amount = parseFloat(contract.threshold_amount);
    contract.threshold_recurring_extra_amount =
      parseFloat(contract.threshold_recurring_extra_amount) || 0;
    contract.threshold_recurring_extra_percent =
      parseFloat(contract.threshold_recurring_extra_percent) || 0;
    let transaction_fee = 0;
    if (comparable_value == 0) {
      return 0;
      // tslint:disable-next-line:max-line-length
    } else if (
      comparable_value < contract.threshold_amount ||
      (contract.threshold_amount === undefined &&
        contract.recurring_extra_amount !== undefined)
    ) {
      if (contract.recurring_extra_percent) {
        transaction_fee +=
          (comparable_value * contract.recurring_extra_percent) / 100;
      }
      if (contract.recurring_extra_amount) {
        transaction_fee += contract.recurring_extra_amount;
      }
    } else {
      if (contract.threshold_recurring_extra_percent) {
        transaction_fee +=
          (comparable_value * contract.threshold_recurring_extra_percent) / 100;
      }
      if (contract.threshold_recurring_extra_amount) {
        transaction_fee += contract.threshold_recurring_extra_amount;
      }
    }
    // if (transaction_fee < 0.2) {
    //   return 0;
    // }
    return transaction_fee;
  }

  getCurrentTimezone() {
    let time = new Date().getTimezoneOffset();
    let hours = Math.abs(Math.trunc(time / 60));
    let minutes = ("0" + (time % 60)).slice(-2);
    let user_timezone = "";
    if (time > 0) {
      user_timezone = "-" + hours + minutes;
    } else {
      user_timezone = "+" + hours + minutes;
    }
    return user_timezone;
  }

  device_info() {
    var window = window;
    var document = document;
    // Opera 8.0+
    var isOpera =
      navigator.userAgent.indexOf(" OPR/") >= 0 ||
      navigator.userAgent.indexOf("Opera") >= 0;
    // Firefox 1.0+
    var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
    // Safari 3.0+ '[object HTMLElementConstructor]'
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    // Edge 20+
    var isEdge = navigator.userAgent.indexOf("Edge") > -1;
    // Internet Explorer 6-11
    var isIE =
      typeof document !== "undefined" && !!document.documentMode && !isEdge;
    // Chrome 1 - 71
    var isChrome = !isOpera && !isEdge && !isSafari;
    // Blink engine detection
    var isBlink = (isChrome || isOpera) && window && !!window.CSS;
    var browserInfo = {
      isFirefox: isFirefox,
      isChrome: isChrome,
      isSafari: isSafari,
      isOpera: isOpera,
      isIE: isIE,
      isEdge: isEdge,
      isBlink: isBlink,
    };

    var platform =
      navigator && navigator.platform ? navigator.platform : "unknown";
    var userAgent =
      navigator && navigator.userAgent ? navigator.userAgent : "unknown";
    return {
      browser: browserInfo,
      platform: platform,
      userAgent: userAgent,
      timestamp: new Date().toString(),
    };
  }

  customPopups(data: any, error: any) {
    if (error === 1) {
      this.toasterService.message(data, 3);
    } else if (error === 0) {
      this.toasterService.message(data, 1);
    } else if (error === 2) {
      this.toasterService.message(data, 2);
    } else if (error === 4) {
      this.toasterService.message(data, 4);
    }
  }

  getExactDate(d) {
    return new Date(d.getTime() + d.getTimezoneOffset() * 60000);
  }

  getSSNRegex() {
    return "^[a-zA-Z0-9]*$";
  }

  walletAction(action) {
    this.walletActionSubject.next(action);
  }

  scrollToTop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  findFlagCode(code) {
    const filteritem = this.country_data.filter(
      (item) => item.mobile_code == code
    );
    if (filteritem && filteritem.length) {
      return (filteritem[0]["country_code"] + "").toLocaleLowerCase();
    } else {
      return "";
    }
  }

  get_Payment_method_intent(
    params,
    setupIntentToken,
    saveCard,
    cardResponse,
    extra_data,
    payment_method_type = ""
  ) {
    const final_token = {
      id: setupIntentToken,
      card: {},
      extra_data: extra_data || {},
    };
    this.api(
      "post",
      this.env.request_url + "get_paymentmethod_intent",
      this.urlParams(params)
    ).subscribe((paymentMethod: any) => {
      if (paymentMethod.is_error) {
        this.flagPopUps(paymentMethod.flag, paymentMethod.err);
      } else {
        if (payment_method_type) {
          final_token.card =
            paymentMethod.info.new_model_paymentMethod[payment_method_type];
        } else {
          final_token.card = paymentMethod.info.new_model_paymentMethod.card;
        }
        cardResponse.emit({ token: final_token, save_card: saveCard ? 1 : 0 });
      }
    });
  }

  createStripeElmentsDynamic(clientSecret?, walletAmount?, details?) {
    if (walletAmount) {
      walletAmount = Number(walletAmount) / 100;
    }
    const appearance = {
      theme: "stripe",
      labels: "floating",
    };
    const paymentElementOptions = {
      layout: "tabs",
      fields: {
        billingDetails: {
          name: 'auto',
          email: 'auto'
        },
      },
      defaultValues: {
        billingDetails: {
          name: (details && details['patient_name']) || '',
          email: details && details['email'] || '',
        },
      },
    };
    // tslint:disable-next-line:max-line-length
    this.stripePaymentIntent = this.stripe.elements({
      appearance,
      clientSecret,
    });
    this.linkAuthenticationElement =
      this.stripePaymentIntent.create("linkAuthentication");
    this.stripeAddressElement = this.stripePaymentIntent.create("address", {
      mode: "billing",
      defaultValues: {
        name: (details && details["patient_name"]) || "",
        email: details && details["email"],
        address: {
          line1: (details && details["patient_address"]?.split("||")[0]) || "",
          line2: (details && details["patient_address"]?.split("||")[1]),
          city: (details && details["patient_city"]) || "",
          state: (details && details["patient_state_code"]) || (details && details['patient_state']) || "",
          postal_code: (details && details["patient_zip"]) || null,
          country: (details && details["country_code"]) || "US",
        },
      },
    });
    this.stripeElement2PaymentIntent = this.stripePaymentIntent.create(
      "payment",
      paymentElementOptions
    );

    if (walletAmount) {
      // for google and apple pay implementation
      this.paymentRequestPaymentIntent = this.stripe.paymentRequest({
        country: this.currency_data.country_code,
        currency: this.currency_data.currency_code,
        total: {
          label: "Total",
          amount: parseFloat(((walletAmount || 1) * 100).toFixed(2)),
        },
        requestPayerName: true,
        requestPayerEmail: true,
        disableWallets: ["googlePay", "link"],
      });
      this.paymentRequestLinkMethods = this.stripe
        .elements()
        .create("paymentRequestButton", {
          paymentRequest: this.paymentRequestPaymentIntent,
          style: {
            paymentRequestButton: {
              type: "default",
              theme: "dark",
              height: "45px",
            },
          },
        });
    }

    // this.paymentRequestPaymentIntent.canMakePayment().then(result => {
    //   console.log(result);
    //   this.paymentRequestPaymentIntent.show();
    //   if (result) {
    //     // Mount paymentRequestButtonElement to the DOM
    //   }
    // });
  }

  createSetiID(obj, patient_id) {
    this.setLoader(true);
    this.api(
      "post",
      environment.request_url + "create_payment_intent_customer",
      this.urlParams(obj)
    ).subscribe(async (response) => {
      this.setLoader(false);
      if (response.is_error == 0 && response.client_secret) {
        this.showAddBankButton = true;
        if (
          response.payment_method_type &&
          response.payment_method_type.length &&
          response.payment_method_type.includes("acss_debit")
        ) {
          this.stripe
            .confirmAcssDebitSetup(response.client_secret, {
              payment_method: {
                billing_details: {
                  name: response.patient_name,
                  email: response.email,
                },
              },
            })
            .then((resp) => {
              if (resp.setupIntent) {
                this.setLoader(true);
                const param = {
                  patient_id,
                  setup_id: resp.setupIntent.id,
                  payment_source_type: 1, // for bank
                  bank_status: "succeeded",
                };
                // tslint:disable-next-line:max-line-length
                this.api(
                  "post",
                  environment.request_url + "add_payment_source",
                  this.urlParams(param)
                ).subscribe((data) => {
                  this.setLoader(false);
                  if (data.data && data.data["fingerprint"]) {
                    this.bankAdded$.next(true);
                  } else {
                    this.customPopups(
                      "Something went wrong, please try again later",
                      1
                    );
                  }
                });
              } else {
                const param = {
                  setup_id: resp.setupIntent.id,
                  payment_source_type: 1,
                };
              }
            })
            .catch((err) => {
              console.log("errerrerr", err);
            });
        } else {
          this.createStripeElmentsDynamic(response.client_secret, 0, response);
          if (this.stripeElement2PaymentIntent) {
            this.showAddBankButton = true;
            setTimeout(() => {
              this.stripeElement2PaymentIntent.mount("#payment-element");
            }, 500);
            // if (document.getElementById('#address-element')) {
            //   this.stripeAddressElement.mount('#address-element');
            // }
          }
        }
      } else {
        this.customPopups("Bank not supported for your currency.", 1);
      }
    });
  }
  public gt_get_cookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      // tslint:disable:triple-equals
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  public validateSSN(input) {
    input = (input + "").match(/\d+/g);
    input = input && input.join("");

    if (!/^\d+$/.test(input)) {
      // this.customPopups('Input is non digit', 1);
      return false;
    }

    if (input.length != 9) {
      // this.customPopups('SSN not 9 digit long', 1);
      return false;
    }

    let first_three = input.substring(0, 3);
    let middle_two = input.substring(3, 5);
    let last_four = input.substring(5, 9);
    // ''.substring()

    if (["000", "666"].includes(first_three)) {
      // this.customPopups('Invalid area code', 1);
      return false;
    } else if (["00"].includes(middle_two)) {
      // this.customPopups('Invalid group', 1);
      return false;
    } else if (["0000"].includes(last_four)) {
      // this.customPopups('invalid serial number', 1);
      return false;
    } else if (
      [
        "078051120",
        "111111111",
        "123456789",
        "219099999",
        "999999999",
      ].includes(input)
    ) {
      // this.customPopups('Dummy ssn entered', 1);
      return false;
    } else if (input >= "987654320" && input <= "987654329") {
      // this.customPopups('Dummy ssn series', 1);
      return false;
    } else {
      return true;
    }
  }
  validateCountry(data: any = "") {
    if ((data.length < this.minDocumentIdLength || data.length > this.maxDocumentIdLength)) {
      // this.customPopups("SSN not 9 digit long", 1);
      return false;
    }

    let first_three = data && data.substring(0, 3);
    let middle_two = data && data.substring(3, 5);
    let last_four = data && data.substring(5, 9);
    if (['000'].includes(first_three)) {
      return false;
    } else if (['00'].includes(middle_two)) {
      return false
    } else if (['0000'].includes(last_four)) {
      return false;
    } else {
      return true;
    }
  }

  paymentMethodValidation(type, funding_type) {
    if (this.featureList && this.featureList.length) {
      const featureFilter = this.featureList.find(
        (item) => item.feature_enum === "PAYMENTMETHOD"
      );
      const getFeature = featureFilter
        ? JSON.parse(JSON.stringify(featureFilter))
        : {};
      if (getFeature && getFeature.payment_method) {
        getFeature.payment_method = JSON.parse(getFeature.payment_method);
        // tslint:disable-next-line:max-line-length
        if (
          (type + "").toLocaleUpperCase() != "BANK" &&
          funding_type &&
          !getFeature.payment_method.includes(
            (funding_type + "").toLocaleUpperCase()
          )
        ) {
          this.setLoader(false);
          this.toasterService.message(
            `Payment type ${funding_type} is not supported as per your business plan`,
            3
          );
          return false;
        } else {
          // tslint:disable-next-line:max-line-length
          if (
            (type + "").toLocaleUpperCase() === "BANK" &&
            !getFeature.payment_method.includes("ACH".toLocaleUpperCase())
          ) {
            this.setLoader(false);
            this.toasterService.message(
              `Payment type BANK is not supported as per your business plan`,
              3
            );
            return false;
          } else {
            return true;
          }
        }
      } else {
        this.setLoader(false);
        this.toasterService.message(
          `Payment type is not supported as per your business plan.`,
          3
        );
        return false;
      }
    }
  }
  confirmSetup() {
    return new Promise((resolve, reject) => {
      this.setLoader(true);
      this.stripe
        .confirmSetup({
          elements: this.stripePaymentIntent,
          confirmParams: {
            // Make sure to change this to your payment completion page
            return_url: window.location.href,
          },
          redirect: "if_required",
        })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
          this.setLoader(false);
        });
    });
  }

  async confirmPayment(client_secret) {
    return new Promise((resolve, reject) => {
      this.stripe
        .confirmPayment({
          clientSecret: client_secret,
          // confirmParams: {
          //   // Make sure to change this to your payment completion page
          //   // return_url: window.location.href
          // },
          redirect: "if_required",
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          this.setLoader(false);
        });
    });
  }

  async saveFinancingError({ error_message, error_type, contract_id = 0, split_req_id = 0, payment_intent_id, contract_token = "", patient_id = 0, pc_code = "", panel = "request", error_from_module = '' }) {
    const errorMessages = [
      // "Your card's expiration date is incomplete.",
      'Your card number is incomplete.',
      // "Your card's security code is incomplete.",
      "Your postal code is incomplete.",
      "This field is incomplete.",
      // "Your ZIP is invalid."
    ];
    if (!errorMessages.includes(error_message)) {
      if (typeof payment_intent_id !== "string") {
        payment_intent_id = "static_intenet_id";
      }
      const obj = {
        access_token: "request",
        error_message: error_message || 'Something went wrong, please try again later',
        contract_token,
        contract_id,
        split_req_id,
        payment_intent_id,
        error_type,
        patient_id,
        pc_code,
        panel
      };

      if (error_from_module) {
        obj['error_from_module'] = error_from_module;
      } else if (this.finance_error_from) {
        obj['error_from_module'] = this.finance_error_from;
      }

      let apiEndpoint: string = "store_financing_errors"
      this.api('post', this.env.request_url + apiEndpoint, obj).subscribe((response: any) => {
        // this.finance_error_from = '';
        if (response.is_error == 0) {
          console.log('Financing error saved successfully');
        }
      });
    }
  }
  countryWiseDataFixing(data?: any) {
    const multiCountry = this.defaultCountry && this.defaultCountry['country_code']
    if(multiCountry) {
      return typeof data === "number" ? data.toFixed(2) : data;
    }
    return data;
  }

  countryWiseCommaSeprated(data?: any) {
    let isJPY = this.noDecimalCurrencies.includes(this.currency_data.currency_code.toLowerCase());
    if (typeof (data) == 'string') {
      data = Number(data);
    }
    const multiCountry = this.getDefaultCountry && this.getDefaultCountry['country_code'];
    if (multiCountry === 'US') {
      return isJPY ? Number(data).toLocaleString('en-US', { maximumFractionDigits: 0 }) : Number(data).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    else {
      return isJPY ? data.toFixed(0) : data.toFixed(2);
    }
  }

  validateDateOfBirth(date) {
    return new Promise((resolve, reject) => {
      const getYearThreshold = new Date().getFullYear() - 120;
      const currentDateThreshold = new Date().getDate();
      const currentMonthThreshold = new Date().getMonth() + 1;
      const currentDateYear = new Date().getFullYear();
      let getDate = JSON.parse(JSON.stringify(date));
      getDate = moment(getDate, this.placeFormat).format(
        "MM" +
        this.specialCharacter[0] +
        "DD" +
        this.specialCharacter[0] +
        "YYYY"
      );
      if (!getDate || getDate == "Invalid date") {
        resolve({ dateCheck: false, error: `Please enter a valid date of birth ${this.placeFormat}` })
        return;
      }
      let valueSet;
      if (
        getDate.includes("-") ||
        getDate.includes("/") ||
        getDate.includes(".")
      ) {
        const change =
          getDate.slice(0, 2) +
          "/" +
          getDate.slice(3, 5) +
          "/" +
          getDate.slice(6, 10);
        valueSet = change;
      } else {
        const change =
          getDate.slice(0, 2) +
          "/" +
          getDate.slice(2, 4) +
          "/" +
          getDate.slice(4, 8);
        valueSet = change;
      }
      if (valueSet.includes("/")) {
        const datepart = valueSet && valueSet.split("/");
        const month = parseInt(datepart[0]);
        const day = parseInt(datepart[1]);
        const year = parseInt(datepart[2]);
        // Create a list of days of a month
        const ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (month === 1 || month > 2) {
          if (day > ListofDays[month - 1]) {
            resolve({ dateCheck: false, error: 'Please enter a valid date of birth' })
            return;
          }
        } else if (month === 2) {
          let leapYear = false;
          if ((!(year % 4) && year % 100) || !(year % 400)) {
            leapYear = true;
          }
          if (leapYear === false && day >= 29) {
            resolve({ dateCheck: false, error: 'Please enter a valid date of birth' })
            return;
          } else if (leapYear && day > 29) {
            resolve({ dateCheck: false, error: 'Please enter a valid date of birth' })
            return;
          }
        }
        if (
          Number(datepart[2]) === currentDateYear &&
          month >= currentMonthThreshold
        ) {
          if (day > currentDateThreshold) {
            resolve({ dateCheck: false, error: 'Please enter a valid date of birth' })
            return;
          }
          if (month > currentMonthThreshold) {
            resolve({ dateCheck: false, error: 'Please enter a valid date of birth' })
            return;
          }
        }
        if (datepart[0] === "00" || datepart[1] === "00") {
          resolve({ dateCheck: false, error: 'Please enter a valid date of birth' })
          return;
        }
        if (!datepart[0] || !Number(datepart[1]) || !Number(datepart[2])) {
          resolve({ dateCheck: false, error: 'Please enter a valid date of birth' })
          return;
        }
        if (
          Number(datepart[2]) < getYearThreshold ||
          Number(datepart[2]) > currentDateYear
        ) {
          if (Number(datepart[2]) < getYearThreshold) {
            if (Number(datepart[2].length < 4)) {
              resolve({ dateCheck: false, error: `Please enter date of birth ${this.placeFormat}` })
              return;
            } else {
              resolve({ dateCheck: false, error: 'Please enter a valid date of birth' })
              return;
            }
          } else {
            resolve({ dateCheck: false, error: 'Please enter a valid date of birth' })
            return;
          }
        }
      }
      resolve({ dateCheck: true, validateDate: valueSet })
      return;
    })
  }

  handleInputSpace(event) {
    const ff = /^[a-zA-Z0-9_ ]+$/;
    if (
      !ff.test(event.key) ||
      (event.target.selectionStart === 0 && event.code === 'Space')
    ) {
      event.preventDefault();
    }
  }

  getZip(item: any) {
    this.setLoader(true);
    return this.newApi('post', environment.request_url + 'add_address_line_two', { addressObj: item });
  }
  
}

class customQueryEncoder {
  encodeKey(k: string): string {
    return this.encode(k);
  }
  encodeValue(v: string): string {
    return this.encode(v);
  }

  public encode(v: string): string {
    return (
      encodeURIComponent(v)
        .replace(/%40/gi, '@')
        .replace(/%7B/gi, '{')
        .replace(/%7D/gi, '}')
        .replace(/%22/gi, '"')
        .replace(/%20/gi, " ")
        .replace(/%7C/gi, "|")
        .replace(/%3A/gi, ":")
        .replace(/%24/gi, "$")
        .replace(/%2C/gi, ",")
        .replace(/%3B/gi, ";")
        .replace(/%2B/gi, '+')
        .replace(/%3D/gi, ";")
        .replace(/%3F/gi, "?")
        .replace(/%2F/gi, "/")
        .replace(/%20/gi, " ")
        .replace(/%7C/gi, `'`)
        .replace(/%21/gi, "!")
        .replace(/%2A/gi, "*")
        .replace(/%5E/gi, "^")
        .replace(/%28/gi, "(")
        .replace(/%29/gi, ")")
        .replace(/%26/gi, '&')
    );
  }
}